const DEFAULT_CAROUSEL_QUOTE_CONFIG = {
  friendlyNameFields: [
    'FriendlyName',
    'CompanyName',
    'BrandName',
    'Provider',
    'ProviderName',
    'ProductProvider',
    'schemename',
    'ispName',
    'name',
  ],
  coverTypeFields: [
    'CoverType',
    'ProductName',
    'BrandText',
    'optiontype',
    'optionname',
    'name',
  ],
  displayAmountFields: [
    'TotalPremium',
    'PremiumAmount',
    'MonthlyPremium',
    'MonthlyPremiumAmount',
    'TotalMonthlyPremium',
    'Premium',
    'totalPremium',
    'premiumAmount',
    'monthlyPremium',
    'premium.monthlypremium_total',
    'monthlyPrice',
  ],
  idFields: ['QuotePK', 'MessageId', 'BrandId', 'optionid', 'id'],
  displayAmountCaption: 'From',
  displayAmountPrefix: 'R',
  displayAmountSuffix: 'pm',
  bestDealSort: 'asc',
};

const CAROUSEL_QUOTE_PRODUCT_CONFIGS = [
  {
    productNames: ['Car Insurance'],
    crossSellKey: 'latestCarInsuranceQuotes_CrossSell',
    fallbackKeys: ['latestVehicleQuotes'],
    friendlyNameFields: ['FriendlyName'],
    navigateTo: '/vehicleQuoteResults',
    landingPath: '/car-insurance-quote/',
  },
  {
    productNames: ['Building Insurance'],
    crossSellKey: 'latestBuildingInsuranceQuotes_CrossSell',
    fallbackKeys: ['latestBuildingInsuranceQuotes'],
    friendlyNameFields: ['FriendlyName'],
    navigateTo: '/buildingInsuranceQuoteResults',
    landingPath: '/buildings-insurance-quote/',
  },
  {
    productNames: ['Home Contents', 'Home Contents Insurance'],
    crossSellKey: 'latestHomeContentsQuotes_CrossSell',
    fallbackKeys: ['latestHomeContentsQuotes'],
    friendlyNameFields: ['FriendlyName'],
    navigateTo: '/homeContentsQuoteResults',
    landingPath: '/home-insurance-quote/',
  },
  {
    productNames: ['Life Insurance'],
    crossSellKey: 'latestLifeInsuranceQuotes_CrossSell',
    fallbackKeys: ['latestLifeInsuranceQuotes'],
    friendlyNameFields: ['FriendlyName'],
    navigateTo: '/lifeQuoteResults',
    landingPath: '/life-insurance-quote/',
  },
  {
    productNames: ['Funeral Insurance'],
    crossSellKey: 'latestFuneralInsuranceQuotes_CrossSell',
    fallbackKeys: ['latestFuneralQuotes'],
    friendlyNameFields: ['FriendlyName'],
    navigateTo: '/funeralQuoteResults',
    landingPath: '/funeral-insurance-quote/',
  },
  {
    productNames: ['Motorcycle Insurance', 'Motor Cycle Insurance'],
    crossSellKey: 'latestMotorcycleInsuranceQuotes_CrossSell',
    fallbackKeys: ['latestMotorcycleInsuranceQuotes'],
    friendlyNameFields: ['FriendlyName'],
    navigateTo: '/motorcycleQuoteResults',
    landingPath: '/motorcycle-insurance-quote/',
  },
  {
    productNames: ['Motor Warranty', 'Motor Warranty Insurance'],
    crossSellKey: 'latestMotorWarrantyQuotes_CrossSell',
    fallbackKeys: ['latestMotorWarrantyQuotes'],
    friendlyNameFields: ['FriendlyName'],
    navigateTo: '/motorWarrantyQuoteResults',
    landingPath: '/motor-warranty/',
  },
  {
    productNames: ['Service Plan', 'Service Plans', 'Car Service Plan'],
    crossSellKey: 'latestServicePlanQuotes_CrossSell',
    fallbackKeys: ['latestServicePlansQuotes'],
    friendlyNameFields: ['FriendlyName'],
    navigateTo: '/servicePlansQuoteResults',
    landingPath: '/service-plan-quotes/',
  },
  {
    productNames: [
      'Tyre & Rim',
      'Tyre and Rim',
      'Tyre & Rim Insurance',
      'Tyre and Rim Insurance',
      'Tyre & Rim Guard',
    ],
    crossSellKey: 'latestTyreRimQuotes_CrossSell',
    fallbackKeys: ['latestTyreAndRimQuotes'],
    friendlyNameFields: ['FriendlyName'],
    navigateTo: '/tyreAndRimQuoteResults',
    landingPath: '/tyre-and-rim-guard/',
  },
  {
    productNames: ['Medical Aid'],
    crossSellKey: 'latestMedicalAidQuotes_CrossSell',
    fallbackKeys: ['latestMedicalAidQuotes'],
    friendlyNameFields: ['schemename'],
    coverTypeFields: ['optiontype', 'optionname'],
    displayAmountFields: ['premium.monthlypremium_total'],
    idFields: ['optionid', 'QuotePK'],
    navigateTo: '/medicalAidQuoteResults',
    landingPath: '/medical-aid-quote/',
  },
  {
    productNames: ['Fibre'],
    crossSellKey: 'latestFibreOffers_CrossSell',
    fallbackKeys: ['latestFibreOffers'],
    friendlyNameFields: ['ispName'],
    coverTypeFields: ['name', 'contractTermString'],
    displayAmountFields: ['monthlyPrice'],
    idFields: ['id', 'quoteid'],
    navigateTo: '/fibreQuoteResults',
    landingPath: '/compare-fibre-deals/',
  },
  {
    productNames: [
      'Medical Gap',
      'Medical Gap Cover',
      'Gap Cover',
      'Medical Gap Cover Insurance',
    ],
    crossSellKey: 'latestMedicalGapQuotes_CrossSell',
    fallbackKeys: ['latestMedicalGapQuotes'],
    friendlyNameFields: ['CompanyName'],
    navigateTo: '/medicalGapQuoteResults',
    landingPath: '/medical-gap-cover-quote/',
  },
  {
    productNames: ['Medical Insurance'],
    crossSellKey: 'latestMedicalInsuranceQuotes_CrossSell',
    fallbackKeys: ['latestMedicalInsuranceQuotes'],
    friendlyNameFields: ['CompanyName'],
    navigateTo: '/medicalInsuranceQuoteResults',
    landingPath: '/medical-insurance-quotes/',
  },
  {
    productNames: ['Vehicle Tracking', 'Vehicle Tracking Insurance'],
    crossSellKey: 'latestVehicleTrackingQuotes_CrossSell',
    fallbackKeys: ['latestVehicleTrackingQuotes'],
    friendlyNameFields: ['CompanyName'],
    navigateTo: '/vehicleTrackingQuoteResults',
    landingPath: '/vehicle-tracking-quote/',
  },
  {
    productNames: ['Pet Insurance', 'Pet'],
    crossSellKey: 'latestPetQuotes_CrossSell',
    fallbackKeys: ['latestPetQuotes'],
    friendlyNameFields: ['CompanyName'],
    navigateTo: '/petQuoteResults',
    landingPath: '/pet-insurance-quote/',
  },
  {
    productNames: ['Travel Insurance', 'Travel'],
    crossSellKey: 'latestTravelQuotes_CrossSell',
    fallbackKeys: ['latestTravelQuotes'],
    friendlyNameFields: ['CompanyName'],
    navigateTo: '/travelQuoteResults',
    landingPath: '/travel-insurance/',
  },
  {
    productNames: [
      'Scratch & Dent',
      'Scratch and Dent',
      'Scratch & Dent Insurance',
      'Scratch and Dent Insurance',
      'Dents & Scratches',
      'Dents and Scratches',
    ],
    crossSellKey: 'latestScratchAndDentQuotes_CrossSell',
    fallbackKeys: ['latestScratchAndDentQuotes'],
    friendlyNameFields: ['CompanyName'],
    navigateTo: '/scratchAndDentQuoteResults',
    landingPath: '/dents-and-scratches-quote/',
  },
  {
    productNames: ['Debt Counselling'],
    crossSellKey: 'latestDebtCounsellingQuotes_CrossSell',
    fallbackKeys: ['latestDebtCounsellingQuotes'],
    friendlyNameFields: ['CompanyName'],
    navigateTo: '/debtCounsellingQuoteResults',
    landingPath: '/debt-counselling/',
  },
  {
    productNames: ['Personal Loan', 'Personal Loans'],
    crossSellKey: 'latestPersonalLoanQuotes_CrossSell',
    fallbackKeys: ['latestPersonalLoanQuotes'],
    friendlyNameFields: ['BrandName'],
    coverTypeFields: ['ProductName'],
    coverTypeFallback: 'Personal Loan',
    displayAmountFields: [
      'Amount',
      'LoanAmount',
      'OfferAmount',
      'TotalPremium',
    ],
    displayAmountCaption: 'Loan Amount',
    displayAmountSuffix: '',
    idFields: ['MessageId', 'QuotePK'],
    bestDealSort: 'desc',
    navigateTo: '/personalLoanQuoteResults',
    landingPath: '/personal-loans/',
  },
  {
    productNames: ['Debt Consolidation'],
    crossSellKey: 'latestDebtConsolidationQuotes_CrossSell',
    fallbackKeys: ['latestDebtConsolidationQuotes'],
    friendlyNameFields: ['BrandName'],
    coverTypeFields: ['ProductName'],
    coverTypeFallback: 'Debt Consolidation',
    displayAmountFields: [
      'Amount',
      'LoanAmount',
      'OfferAmount',
      'TotalPremium',
    ],
    displayAmountCaption: 'Loan Amount',
    displayAmountSuffix: '',
    idFields: ['MessageId', 'QuotePK'],
    bestDealSort: 'desc',
    navigateTo: '/debtConsolidationQuoteResults',
    landingPath: '/debt-consolidation-loans/',
  },
  {
    productNames: ['Business Insurance'],
    crossSellKey: 'latestBusinessInsuranceQuotes_CrossSell',
    fallbackKeys: ['latestBusinessInsuranceQuotes'],
    friendlyNameFields: ['BrandName'],
    coverTypeFields: ['BrandText', 'ProductName'],
    idFields: ['QuotePK', 'BrandId'],
    navigateTo: '/businessInsuranceQuoteResults',
    landingPath: '/business-insurance-quote/',
  },
  {
    productNames: ['Business Legal Cover'],
    crossSellKey: 'latestBusinessLegalCoverQuotes_CrossSell',
    fallbackKeys: ['latestBusinessLegalCoverQuotes'],
    friendlyNameFields: ['BrandName'],
    coverTypeFields: ['BrandText', 'ProductName'],
    idFields: ['QuotePK', 'BrandId'],
    navigateTo: '/businessLegalCoverQuoteResults',
    landingPath: '/business-insurance-quote/business-legal-cover/',
  },
  {
    productNames: ['Commercial Property', 'Commercial Property Insurance'],
    crossSellKey: 'latestCommercialPropertyQuotes_CrossSell',
    fallbackKeys: ['latestCommercialPropertyQuotes'],
    friendlyNameFields: ['BrandName'],
    coverTypeFields: ['BrandText', 'ProductName'],
    idFields: ['QuotePK', 'BrandId'],
    navigateTo: '/commercialPropertyQuoteResults',
    landingPath:
      '/business-insurance-quote/car-and-commercial-property-insurance/',
  },
  {
    productNames: ['Professional Liability', 'Professional Indemnity'],
    crossSellKey: 'latestProfessionalLiabilityQuotes_CrossSell',
    fallbackKeys: ['latestProfessionalLiabilityQuotes'],
    friendlyNameFields: ['BrandName'],
    coverTypeFields: ['BrandText', 'ProductName'],
    idFields: ['QuotePK', 'BrandId'],
    navigateTo: '/professionalLiabilityQuoteResults',
    landingPath:
      '/business-insurance-quote/professional-liability-insurance-cover/',
  },
];

export const CROSS_SELL_STORAGE_KEYS = CAROUSEL_QUOTE_PRODUCT_CONFIGS.reduce(
  (acc, config) => {
    config.productNames.forEach((productName) => {
      acc[productName] = config.crossSellKey;
    });
    return acc;
  },
  {}
);

export const getProductConfigByCrossSellKey = (crossSellKey) =>
  CAROUSEL_QUOTE_PRODUCT_CONFIGS.find((c) => c.crossSellKey === crossSellKey);

export function markProductChosen(fallbackKey) {
  if (!fallbackKey) return;
  try {
    localStorage.setItem(`${fallbackKey}_chosen`, 'true');
  } catch (e) {
    // storage unavailable
  }
}

export function unmarkProductChosen(fallbackKey) {
  if (!fallbackKey) return;
  try {
    localStorage.removeItem(`${fallbackKey}_chosen`);
  } catch (e) {
    // storage unavailable
  }
}

export function isProductChosen(fallbackKey) {
  if (!fallbackKey) return false;
  try {
    return localStorage.getItem(`${fallbackKey}_chosen`) === 'true';
  } catch {
    return false;
  }
}

// Question-engine product slug -> chosen-flag fallback key.
const QUESTION_FLOW_PRODUCT_TO_FALLBACK_KEY = {
  CarInsurance: 'latestVehicleQuotes',
  ReturningUser: 'latestVehicleQuotes',
  AdditionalDriver: 'latestVehicleQuotes',
  MotorcycleInsurance: 'latestMotorcycleInsuranceQuotes',
  AdditionalMotorCycleDriver: 'latestMotorcycleInsuranceQuotes',
  MotorWarranty: 'latestMotorWarrantyQuotes',
  'Scratch&DentCover': 'latestScratchAndDentQuotes',
  'Tyre&RimCover': 'latestTyreAndRimQuotes',
  VehicleTracking: 'latestVehicleTrackingQuotes',
  ServicePlans: 'latestServicePlansQuotes',
  GapCover: 'latestMedicalGapQuotes',
  MedicalAid: 'latestMedicalAidQuotes',
  MedicalInsurance: 'latestMedicalInsuranceQuotes',
  LifeInsurance: 'latestLifeInsuranceQuotes',
  FuneralInsurance: 'latestFuneralQuotes',
  PetInsurance: 'latestPetQuotes',
  TravelInsurance: 'latestTravelQuotes',
  DebtCounselling: 'latestDebtCounsellingQuotes',
  DebtConsolidation: 'latestDebtConsolidationQuotes',
  PersonalLoans: 'latestPersonalLoanQuotes',
  BusinessInsurance: 'latestBusinessInsuranceQuotes',
  BusinessLegalCover: 'latestBusinessLegalCoverQuotes',
  CommercialProperty: 'latestCommercialPropertyQuotes',
  ProfessionalLiability: 'latestProfessionalLiabilityQuotes',
  BuildingInsurance: 'latestBuildingInsuranceQuotes',
  HomeContentsCover: 'latestHomeContentsQuotes',
  FibreInternet: 'latestFibreOffers',
};

// A question flow submitting for fresh quotes is a deliberate re-quote, so
// the product's chosen flag must be cleared for its results page to render.
export function unmarkProductChosenForQuestionFlow(product) {
  unmarkProductChosen(QUESTION_FLOW_PRODUCT_TO_FALLBACK_KEY[product]);
}

// Once a quote has been accepted for a product, browser back navigation
// should never re-show the (now stale) results for it - send the user to the
// product's landing page instead so they'd have to re-quote from scratch.
export function getLandingPathForFallbackKey(fallbackKey) {
  const config = CAROUSEL_QUOTE_PRODUCT_CONFIGS.find((c) =>
    c.fallbackKeys.includes(fallbackKey)
  );
  return config?.landingPath || '/';
}

const CAROUSEL_QUOTE_CONFIG_BY_STORAGE_KEY =
  CAROUSEL_QUOTE_PRODUCT_CONFIGS.reduce((acc, config) => {
    [config.crossSellKey, ...config.fallbackKeys].forEach((storageKey) => {
      acc[storageKey] = config;
    });
    return acc;
  }, {});

const CAROUSEL_QUOTE_CONFIG_BY_PRODUCT_NAME =
  CAROUSEL_QUOTE_PRODUCT_CONFIGS.reduce((acc, config) => {
    config.productNames.forEach((productName) => {
      acc[productName] = config;
    });
    return acc;
  }, {});

function getByPath(source, path) {
  return path.split('.').reduce((value, part) => value?.[part], source);
}

function pickFirst(source, paths) {
  for (const path of paths) {
    const value = getByPath(source, path);
    if (value !== undefined && value !== null && value !== '') return value;
  }
  return undefined;
}

function mergeCarouselQuoteConfig(config) {
  return {
    ...DEFAULT_CAROUSEL_QUOTE_CONFIG,
    ...config,
    friendlyNameFields: [
      ...(config?.friendlyNameFields || []),
      ...DEFAULT_CAROUSEL_QUOTE_CONFIG.friendlyNameFields,
    ],
    coverTypeFields: [
      ...(config?.coverTypeFields || []),
      ...DEFAULT_CAROUSEL_QUOTE_CONFIG.coverTypeFields,
    ],
    displayAmountFields: [
      ...(config?.displayAmountFields || []),
      ...DEFAULT_CAROUSEL_QUOTE_CONFIG.displayAmountFields,
    ],
    idFields: [
      ...(config?.idFields || []),
      ...DEFAULT_CAROUSEL_QUOTE_CONFIG.idFields,
    ],
  };
}

function getCarouselQuoteConfig({ productName, storageKey }) {
  return mergeCarouselQuoteConfig(
    CAROUSEL_QUOTE_CONFIG_BY_STORAGE_KEY[storageKey] ||
      CAROUSEL_QUOTE_CONFIG_BY_PRODUCT_NAME[productName]
  );
}

function normalizeCarouselQuote(quote, config, index) {
  const sourceQuote = quote || {};
  const quoteId = pickFirst(sourceQuote, config.idFields) ?? index;
  const displayAmount = pickFirst(sourceQuote, config.displayAmountFields);

  return {
    ...sourceQuote,
    QuotePK: quoteId,
    FriendlyName: pickFirst(sourceQuote, config.friendlyNameFields) ?? '',
    CoverType:
      pickFirst(sourceQuote, config.coverTypeFields) ??
      config.coverTypeFallback ??
      '',
    DisplayAmount: displayAmount,
    DisplayAmountCaption: config.displayAmountCaption,
    DisplayAmountPrefix: config.displayAmountPrefix,
    DisplayAmountSuffix: config.displayAmountSuffix,
    TotalPremium: displayAmount,
  };
}

function applyCarouselBestDeal(quotes, config) {
  const hasBestDealFromSource = quotes.some(
    (quote) => quote.bestDeal !== undefined
  );

  if (hasBestDealFromSource) {
    return quotes;
  }

  const rankedQuotes = quotes
    .map((quote, index) => ({
      quote,
      index,
      premium: Number(quote.TotalPremium),
    }))
    .filter(({ premium }) => Number.isFinite(premium))
    .sort((a, b) =>
      config.bestDealSort === 'desc'
        ? b.premium - a.premium
        : a.premium - b.premium
    );

  const best = rankedQuotes[0];
  if (!best) return quotes;

  return quotes.map((quote, index) => ({
    ...quote,
    bestDeal:
      quote.QuotePK === best.quote.QuotePK ||
      (quote.QuotePK === undefined && index === best.index),
  }));
}

export function normalizeStoredQuotesForCarousel(quotes, storageKey) {
  if (!Array.isArray(quotes)) return [];

  const config = getCarouselQuoteConfig({ storageKey });
  const normalizedQuotes = quotes.map((quote, index) =>
    normalizeCarouselQuote(quote, config, index)
  );

  return applyCarouselBestDeal(normalizedQuotes, config);
}

function getCrossSellQuotesForCarousel(item) {
  const rawQuotes = Array.isArray(item?.Quotes) ? item.Quotes : [];

  if (item?.ProductName === 'Medical Aid') {
    return rawQuotes.flatMap((personQuote) =>
      Array.isArray(personQuote?.Quotes) ? personQuote.Quotes : [personQuote]
    );
  }

  return rawQuotes;
}

export function normalizeQuotesForCarousel(item) {
  const storageKey = CROSS_SELL_STORAGE_KEYS[item?.ProductName];
  const config = getCarouselQuoteConfig({
    productName: item?.ProductName,
    storageKey,
  });
  const rawQuotes = getCrossSellQuotesForCarousel(item);
  const normalizedQuotes = rawQuotes.map((quote, index) =>
    normalizeCarouselQuote(quote, config, index)
  );

  return applyCarouselBestDeal(normalizedQuotes, config);
}

export function persistCrossSellQuotes(crossSellResponse) {
  const items = crossSellResponse?.CrossSell;
  if (!Array.isArray(items)) return;
  items.forEach((item) => {
    const key = CROSS_SELL_STORAGE_KEYS[item.ProductName];
    if (!key) return;
    const quotes = normalizeQuotesForCarousel(item);
    const stored = { Quotes: quotes };
    if (item.QuoteDetails != null) {
      stored.QuoteDetails = item.QuoteDetails;
    }
    localStorage.setItem(key, JSON.stringify(stored));
  });
}

export function getAllCrossSellBestDealQuotes() {
  const result = [];
  for (const config of CAROUSEL_QUOTE_PRODUCT_CONFIGS) {
    try {
      const raw = localStorage.getItem(config.crossSellKey);
      if (!raw) continue;
      const parsed = JSON.parse(raw);
      const quotes = Array.isArray(parsed)
        ? parsed
        : Array.isArray(parsed?.Quotes)
          ? parsed.Quotes
          : [];
      if (quotes.length === 0) continue;
      const best = quotes.find((q) => q.bestDeal === true) ?? quotes[0];
      result.push({
        ...best,
        bestDeal: false,
        navigateTo: config.navigateTo,
        productCategory: config.productNames[0],
        crossSellStorageKey: config.crossSellKey,
      });
    } catch {
      // skip categories with invalid stored data
    }
  }
  return result;
}
